import axios from 'axios';

class ForgotPasswordServiceClass {
  forgotPassword(email) {
    return axios.post('/api/auth/ForgotPassword', {
      Username: email,
      IsLabelApi: false,
    });
  }
}

export const ForgotPasswordService = new ForgotPasswordServiceClass();
